import axios from 'axios';
import { API_CONFIG } from '../config/api';

const API_BASE_URL = API_CONFIG.baseURL;

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: API_CONFIG.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401 Unauthorized
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove token and redirect to login
      localStorage.removeItem('adminToken');
      
      // Only redirect if not already on login page
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export const skiPassAPI = {
  
  getAllSkiPasses: () => api.get('/ski-passes'),
  
  
  getSkiPassById: (id) => api.get(`/ski-passes/${id}`),
  
  
  createSkiPass: (skiPassData) => api.post('/ski-passes', skiPassData),
  
  
  updateSkiPass: (id, skiPassData) => api.put(`/ski-passes/${id}`, skiPassData),
  
  
  deleteSkiPass: (id) => api.delete(`/ski-passes/${id}`),
};

export default api;
